import { Crosshair, LayoutDashboard, ListChecks, FileClock, Settings2, Store, LogOut, Briefcase, Link2, BarChart3, CalendarClock, Mail, Inbox as InboxIcon, Flame, Rocket } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useBranding } from "@/lib/branding";

const NAV = [
  { icon: LayoutDashboard, label: "Dashboard", to: "/dashboard" },
  { icon: InboxIcon, label: "Inbox", to: "/inbox" },
  { icon: Flame, label: "Hot Leads", to: "/hot-leads" },
  { icon: CalendarClock, label: "Drops", to: "/drops" },
  { icon: Briefcase, label: "Portfolio", to: "/portfolio" },
  { icon: Store, label: "Listings", to: "/listings" },
  { icon: BarChart3, label: "Analytics", to: "/analytics" },
  { icon: Mail, label: "Mail", to: "/mail" },
  { icon: Rocket, label: "Projects", to: "/admin/projects" },
  { icon: Link2, label: "Affiliate", to: "/affiliate" },
  { icon: Settings2, label: "Settings", to: "/settings" },
];

export default function Sidebar({ status = {} }) {
  const auth = useAuth();
  const brand = useBranding();
  const { pathname } = useLocation();
  const isActive = (to) => {
    if (to === "/") return pathname === "/";
    return pathname === to || pathname.startsWith(`${to}/`);
  };
  const badge = (ok) =>
    ok
      ? { text: "READY", bg: "#ECFDF5", fg: "#047857" }
      : { text: "SETUP", bg: "#FFFBEB", fg: "#B45309" };
  const t = badge(status.transip_configured);
  const s = badge(status.spaceship_configured);
  return (
    <aside
      data-testid="sidebar"
      className="w-[240px] shrink-0 flex flex-col justify-between"
      style={{ background: "var(--cd-navy-950)", color: "#fff", fontFamily: "var(--cd-font)" }}
    >
      <div>
        <div className="h-16 px-6 flex items-center gap-3" style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          <span className="cd-brand__symbol" aria-hidden />
          <div
            data-testid="sidebar-brand"
            style={{ fontWeight: 800, fontSize: 15, letterSpacing: "-0.02em", color: "#fff" }}
          >
            Casper<span style={{ fontWeight: 650 }}>Domains</span>
          </div>
        </div>
        <nav className="py-4">
          <div className="px-6 mb-3" style={{ fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase", color: "rgba(255,255,255,0.42)" }}>Menu</div>
          <ul>
            {NAV.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className="w-full text-left px-6 py-2.5 flex items-center gap-3 text-sm transition-colors"
                  style={{
                    color: isActive(item.to) ? "#fff" : "rgba(255,255,255,0.68)",
                    background: isActive(item.to) ? "rgba(75,111,255,0.14)" : "transparent",
                    borderLeft: isActive(item.to) ? "2px solid var(--cd-cyan-400)" : "2px solid transparent",
                    fontWeight: isActive(item.to) ? 600 : 500,
                  }}
                >
                  <item.icon strokeWidth={1.5} className="w-4 h-4" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="mt-2 px-6 py-4" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          <div className="mb-2" style={{ fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase", color: "rgba(255,255,255,0.42)" }}>Registrars</div>
          <ul className="space-y-2 text-sm" style={{ fontSize: 13 }}>
            <li className="flex items-center justify-between" style={{ color: "rgba(255,255,255,0.8)" }}>
              <span>TransIP.nl</span>
              <span
                className="text-[10px] px-1.5 py-0.5 rounded-sm font-medium"
                style={{ background: t.bg, color: t.fg }}
              >
                {t.text}
              </span>
            </li>
            <li className="flex items-center justify-between" style={{ color: "rgba(255,255,255,0.8)" }}>
              <span>Spaceship</span>
              <span
                className="text-[10px] px-1.5 py-0.5 rounded-sm font-medium"
                style={{ background: s.bg, color: s.fg }}
              >
                {s.text}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="px-6 py-4 flex items-center gap-3" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <img
          src={brand.avatar_url || "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwcm9maWxlJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgzMDk4MDkzfDA&ixlib=rb-4.1.0&q=85"}
          alt="user"
          className="w-9 h-9 rounded-full object-cover"
          style={{ border: "2px solid rgba(255,255,255,0.15)" }}
        />
        <div className="min-w-0 flex-1">
          <div className="text-xs font-medium truncate" style={{ color: "#fff" }}>{auth?.user?.email || "Operator One"}</div>
          <div className="text-[10px]" style={{ color: "rgba(255,255,255,0.42)", letterSpacing: "0.12em", textTransform: "uppercase" }}>Admin session</div>
        </div>
        {auth?.user && (
          <button
            onClick={auth.logout}
            data-testid="logout-btn"
            title="Sign out"
            className="p-1"
            style={{ color: "rgba(255,255,255,0.6)", background: "transparent", border: 0, cursor: "pointer" }}
          >
            <LogOut className="w-4 h-4" strokeWidth={1.5} />
          </button>
        )}
      </div>
    </aside>
  );
}
